export default {
    name: 'rate',
    definition: {
        amount: '',
        startdate: '',
    },
};
